module.exports = __webpack_public_path__ + "img/sneakers.f836c655.png";